export const ANNOTATION_LABEL = {
  DUPLICATE_COLOR_ERROR: 'This color is already in use. Choose a different one for your class.'
};